import React from 'react';
import { ObjectWrapper } from './styles/Common.styles';
import {
  TimeInputRow,
  TimeInputWrapper,
  TimeSegmentsContainer,
  TimeSegment,
  SpinnerImage
} from './styles/TimeInput.styles';

const TimeInputControl = ({ control }) => {
  const timeString = control.defaultValue || '';
  const [time, ampm] = timeString.split(' ');
  const [hours = '', minutes = '', seconds = ''] = time.split(':');

  return (
    <ObjectWrapper>
      <TimeInputRow>
        <TimeInputWrapper styleProps={control.attributes} height={control.height}>
          <TimeSegmentsContainer styleProps={control.attributes}>
            <TimeSegment>{hours}</TimeSegment>
            <span>:</span>
            <TimeSegment>{minutes}</TimeSegment>
            {control.hasSeconds && (
              <>
                <span>:</span>
                <TimeSegment>{seconds}</TimeSegment>
              </>
            )}
            {ampm && <TimeSegment style={{ flex: '0.5' }}>{ampm}</TimeSegment>}
          </TimeSegmentsContainer>
        </TimeInputWrapper>
        <SpinnerImage alt="Time Spinner" />
      </TimeInputRow>
    </ObjectWrapper>
  );
};

export default TimeInputControl;